(function () {
    if (window.__lumerisaFinalCartInstalled) return;
    window.__lumerisaFinalCartInstalled = true;

    var MONEY_CONFIG = window.LumerisaMoneyConfig || {};
    var I18N = window.LumerisaI18n || {};
    var BASE_CURRENCY = MONEY_CONFIG.baseCurrency || (window.LumerisaMoneyConfig && window.LumerisaMoneyConfig.baseCurrency) || 'EUR';
    var FREE_REWARD_THRESHOLD_BASE = Number(MONEY_CONFIG.freeGiftBaseCents) || 20000;
    var FREE_SHIPPING_THRESHOLD_BASE = Number(MONEY_CONFIG.freeShippingBaseCents) || 7500;
    var FREE_GIFT_COMPARE_PRICE_BASE = Number(MONEY_CONFIG.giftCompareBaseCents) || 4000;
    var FREE_GIFT_COLLECTION_HANDLE = 'half-zips';
    var FREE_GIFT_PRODUCT_HANDLE = 'ibiza-t-shirt-kopie';
    var FREE_GIFT_VARIANT_ID = '57983484952921';
    var FREE_GIFT_UNLOCK_KEY = 'lumerisa_free_gift_unlocked';
    var FREE_GIFT_UNLOCK_TIME_KEY = 'lumerisa_free_gift_unlocked_at';
    var FREE_GIFT_SESSION_MINUTES = 30;
    var FREE_GIFT_DISCOUNT_CODE = '';
    var RESERVATION_SECONDS = 600;

    var cart = document.querySelector('[data-lumerisa-cart]');
    var overlay = document.querySelector('[data-lumerisa-cart-overlay]');
    var body = document.querySelector('[data-lumerisa-cart-body]');
    var subtotal = document.querySelector('[data-lumerisa-cart-subtotal]');
    var shipping = document.querySelector('[data-lumerisa-cart-shipping]');
    var closeButton = document.querySelector('[data-lumerisa-cart-close]');
    var cartCount = document.querySelector('[data-lumerisa-cart-count]');
    var rewardTitle = document.querySelector('[data-lumerisa-reward-title]');
    var rewardStep = document.querySelector('[data-lumerisa-reward-step]');
    var progressFill = document.querySelector('[data-lumerisa-progress-fill]');
    var giftBox = document.querySelector('[data-lumerisa-gift-box]');
    var giftButton = document.querySelector('[data-lumerisa-gift-button]');
    var giftImageWrap = document.querySelector('[data-lumerisa-gift-image-wrap]');
    var timerEl = document.querySelector('[data-lumerisa-cart-timer]');
    var checkoutLink = document.querySelector('[data-lumerisa-checkout]');
    var reservationInterval = null;
    var priceRefreshTimer = null;
    var giftPreviewLoaded = false;

    if (!cart || !overlay || !body || !subtotal) return;

    function tr(key, replacements) {
      var value = String(I18N[key] || '');
      var vars = replacements || {};
      Object.keys(vars).forEach(function (name) {
        value = value.split('__' + name.toUpperCase() + '__').join(String(vars[name]));
      });
      return value;
    }

    function storefrontRoute(path) {
      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
    }

    function getActiveCurrency(currency) {
      return (
        currency ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        BASE_CURRENCY
      );
    }

    function getCurrencyRate(currency) {
      var activeCurrency = getActiveCurrency(currency);
      if (activeCurrency === BASE_CURRENCY) return 1;

      var shopifyCurrency = window.Shopify && window.Shopify.currency;
      var rate = shopifyCurrency ? Number(shopifyCurrency.rate) : NaN;
      if (
        shopifyCurrency &&
        shopifyCurrency.active === activeCurrency &&
        Number.isFinite(rate) &&
        rate > 0
      ) {
        return rate;
      }

      return 1;
    }

    function baseToPresentmentCents(baseCents, currency) {
      return Math.round((Number(baseCents) || 0) * getCurrencyRate(currency));
    }

    function getFreeShippingThreshold(currency) {
      return baseToPresentmentCents(FREE_SHIPPING_THRESHOLD_BASE, currency);
    }

    function getFreeRewardThreshold(currency) {
      return baseToPresentmentCents(FREE_REWARD_THRESHOLD_BASE, currency);
    }

    function hasGiftUrlFlag() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get('lumerisa_gift') === '1';
      } catch (error) {
        return window.location.search.indexOf('lumerisa_gift=1') > -1;
      }
    }

    function safeStorageGet(storageName, key) {
      try {
        var storage = window[storageName];
        return storage ? storage.getItem(key) : null;
      } catch (error) {
        return null;
      }
    }

    function safeStorageSet(storageName, key, value) {
      try {
        var storage = window[storageName];
        if (storage) storage.setItem(key, value);
      } catch (error) {
        // Some in-app/private browsers disable Web Storage. Cart functionality must continue without it.
      }
    }

    function safeStorageRemove(storageName, key) {
      try {
        var storage = window[storageName];
        if (storage) storage.removeItem(key);
      } catch (error) {
        // Storage is optional state only; never let it break cart interactions.
      }
    }

    function isGiftCollectionPage() {
      var path = window.location.pathname.replace(/\/$/, '');
      return path.endsWith('/collections/' + FREE_GIFT_COLLECTION_HANDLE);
    }

    function isProductPage() {
      return window.location.pathname.indexOf('/products/') !== -1;
    }

    function syncGiftSessionFromUrl() {
      if (hasGiftUrlFlag() && (isGiftCollectionPage() || isProductPage())) {
        safeStorageSet('sessionStorage', FREE_GIFT_UNLOCK_KEY, 'true');
        safeStorageSet('sessionStorage', FREE_GIFT_UNLOCK_TIME_KEY, String(Date.now()));
      }
    }

    function isGiftSessionActive() {
      syncGiftSessionFromUrl();

      var active = safeStorageGet('sessionStorage', FREE_GIFT_UNLOCK_KEY) === 'true';
      var started = Number(safeStorageGet('sessionStorage', FREE_GIFT_UNLOCK_TIME_KEY) || 0);
      var maxAge = FREE_GIFT_SESSION_MINUTES * 60 * 1000;

      if (!active || !started) return false;

      if (Date.now() - started > maxAge) {
        safeStorageRemove('sessionStorage', FREE_GIFT_UNLOCK_KEY);
        safeStorageRemove('sessionStorage', FREE_GIFT_UNLOCK_TIME_KEY);
        return false;
      }

      return true;
    }

    function activateGiftSession() {
      safeStorageSet('sessionStorage', FREE_GIFT_UNLOCK_KEY, 'true');
      safeStorageSet('sessionStorage', FREE_GIFT_UNLOCK_TIME_KEY, String(Date.now()));
    }

    function clearGiftSession() {
      safeStorageRemove('sessionStorage', FREE_GIFT_UNLOCK_KEY);
      safeStorageRemove('sessionStorage', FREE_GIFT_UNLOCK_TIME_KEY);
    }

    function isGiftModePage() {
      if (!hasGiftUrlFlag()) return false;
      if (!(isGiftCollectionPage() || isProductPage())) return false;
      isGiftSessionActive();
      return true;
    }

    function shouldTreatCurrentAddAsGift() {
      return isGiftModePage();
    }

    function decorateGiftProductLinks() {
      if (!isGiftCollectionPage()) return;
      if (!hasGiftUrlFlag()) return;

      document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        if (link.closest('[data-lumerisa-cart]')) return;

        try {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set('lumerisa_gift', '1');
          link.href = url.pathname + url.search + url.hash;
        } catch (error) {}
      });
    }

    function formatMoney(cents, currency) {
      var activeCurrency = getActiveCurrency(currency);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: activeCurrency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + activeCurrency;
      }
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function imageUrl(url, width) {
      if (!url) return '';
      return String(url) + (String(url).indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    function getBundleDiscountPercent(item) {
      var properties = (item && item.properties) || {};
      /* Support every bundle implementation currently used in the theme.
         The active Complete-the-look bundle stores `_bundle_discount: "10%"`,
         while older bundle blocks use the other property names below. */
      var raw =
        properties._bundle_discount ||
        properties._lc_discount_percent ||
        properties['Bundle discount'] ||
        properties['Set Discount'] ||
        '';
      var parsed = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    }

    function getBundleOriginalLinePrice(item) {
      if (!item) return 0;
      var quantity = Math.max(1, Number(item.quantity) || 1);

      /* Shopify's own per-line original price is the safest source here.
         `_bundle_original_price` used by Complete-the-look is the TOTAL price
         of both products, so it must never be shown as the compare-at price
         for each individual cart line. */
      var shopifyOriginalLine = Number(item.original_line_price);
      if (shopifyOriginalLine > 0) return shopifyOriginalLine;

      var unitOriginal = Number(item.original_price) || Number(item.price) || 0;
      if (unitOriginal > 0) return unitOriginal * quantity;

      /* Legacy single-product bundle fallback only. */
      var properties = item.properties || {};
      var propertyPrice = properties['Original Price'];
      if (propertyPrice) {
        var normalized = String(propertyPrice)
          .replace(/[^0-9,.-]/g, '')
          .replace(/\.(?=.*\.)/g, '')
          .replace(',', '.');
        var parsed = parseFloat(normalized);
        if (Number.isFinite(parsed) && parsed > 0) {
          return Math.round(parsed * 100) * quantity;
        }
      }
      return 0;
    }

    function renderItemPrice(item, cartData, freeGift) {
      if (freeGift) return '<span class="lumerisa-cart__price-current">' + formatMoney(0, cartData.currency) + '</span>';
      // Use actual Shopify line prices; never calculate a 10% reduction from bundle properties.
      var actual = Number(item.final_line_price);
      if (!Number.isFinite(actual)) actual = Number(item.line_price) || 0;
      return '<span class="lumerisa-cart__price-current">' + formatMoney(actual, cartData.currency) + '</span>';
    }

    function loadGiftPreviewImage() {
  if (!giftImageWrap || !FREE_GIFT_PRODUCT_HANDLE) return;

  fetch(storefrontRoute('products/' + encodeURIComponent(FREE_GIFT_PRODUCT_HANDLE) + '.js'), {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      'Accept': 'application/json'
    }
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Free gift product request failed: ' + response.status);
      }

      return response.json();
    })
    .then(function (product) {
      if (!product || !giftImageWrap) return;

      var selectedVariant = null;

      if (product.variants && product.variants.length) {
        selectedVariant = product.variants.find(function (variant) {
          return String(variant.id) === String(FREE_GIFT_VARIANT_ID);
        });
      }

      var image = '';

      if (
        selectedVariant &&
        selectedVariant.featured_image &&
        selectedVariant.featured_image.src
      ) {
        image = selectedVariant.featured_image.src;
      } else if (product.featured_image) {
        image = product.featured_image;
      } else if (product.images && product.images.length) {
        image = product.images[0];
      }

      if (!image || !giftImageWrap) return;

      giftImageWrap.innerHTML =
        '<img class="lumerisa-cart__gift-image" src="' +
        imageUrl(image, 240) +
        '" alt="' + escapeHtml((I18N.freeTshirtGift || I18N.freeGiftSuffix || 'Free T-Shirt Gift')) + '" loading="lazy">';
    })
    .catch(function () {
      if (!giftImageWrap) return;

      giftImageWrap.innerHTML =
        '<div class="lumerisa-cart__gift-placeholder"></div>';
    });
}

    function ensureGiftPreviewImage() {
      if (giftPreviewLoaded) return;
      giftPreviewLoaded = true;
      loadGiftPreviewImage();
    }

    function isFreeGiftItem(item) {
      if (!item) return false;

      var properties = item.properties || {};

      if (properties._free_tshirt_gift === 'true') return true;
      if (properties._free_gift === 'Free T-Shirt Gift') return true;
      if (properties._free_gift_source === 'Lumérisa Cart Reward') return true;

      return false;
    }

    function getCartValueWithoutGift(cartData) {
      return (cartData.items || []).reduce(function (sum, item) {
        if (isFreeGiftItem(item)) return sum;
        return sum + (item.final_line_price || 0);
      }, 0);
    }

    function hasFreeGift(cartData) {
      return (cartData.items || []).some(isFreeGiftItem);
    }

    function openCart() {
      ensureGiftPreviewImage();
      document.documentElement.classList.add('lumerisa-cart-active');
      document.body.classList.add('lumerisa-cart-active');

      overlay.classList.add('is-open');
      cart.classList.add('is-open');
      cart.setAttribute('aria-hidden', 'false');

      startReservationTimer();
    }

    function closeCart() {
      overlay.classList.remove('is-open');
      cart.classList.remove('is-open');
      cart.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('lumerisa-cart-active');
      document.body.classList.remove('lumerisa-cart-active');

      if (reservationInterval) {
        window.clearInterval(reservationInterval);
        reservationInterval = null;
      }
    }

    function setLoading(isLoading) {
      cart.classList.toggle('lumerisa-cart__loading', Boolean(isLoading));
    }

    function startReservationTimer() {
      var storedEnd = Number(safeStorageGet('localStorage', 'lumerisa_cart_reserved_until') || 0);
      var now = Date.now();

      if (!storedEnd || storedEnd <= now) {
        storedEnd = now + RESERVATION_SECONDS * 1000;
        safeStorageSet('localStorage', 'lumerisa_cart_reserved_until', String(storedEnd));
      }

      if (reservationInterval) return;

      function tick() {
        var left = Math.max(0, Math.floor((storedEnd - Date.now()) / 1000));
        var minutes = String(Math.floor(left / 60)).padStart(2, '0');
        var seconds = String(left % 60).padStart(2, '0');

        if (timerEl) timerEl.textContent = minutes + ':' + seconds;

        if (left <= 0) {
          safeStorageRemove('localStorage', 'lumerisa_cart_reserved_until');
          window.clearInterval(reservationInterval);
          reservationInterval = null;
        }
      }

      tick();
      reservationInterval = window.setInterval(tick, 1000);
    }

    function getCart() {
      var root=storefrontRoute('');
      return fetch(storefrontRoute('cart.js'),{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw Error('Cart request failed');return r.json()})
      .then(function(cartData){
        // Remove lingering SET10 from old sessions. Never manufacture a 10% visual discount.
        var codes=cartData.discount_codes||[];
        var stale=codes.some(function(d){return String(d.code||'').toUpperCase()==='SET10'});
        if(!stale)return cartData;
        return fetch(storefrontRoute('cart/update.js'),{method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({discount:''})
        }).then(function(r){return r.ok?r.json():cartData}).catch(function(){return cartData});
      });
    }

    function createGiftPriceHtml(currency) {
      var activeCurrency = getActiveCurrency(currency);
      var compareCents = baseToPresentmentCents(FREE_GIFT_COMPARE_PRICE_BASE, activeCurrency);
      return (
        '<span class="lumerisa-free-price" style="color:#6f1d1b!important;font-weight:500!important;">' + formatMoney(0, activeCurrency) + '</span>' +
        '<span class="lumerisa-free-compare" style="color:#777!important;text-decoration:line-through!important;margin-left:6px!important;">' +
        formatMoney(compareCents, activeCurrency) +
        '</span>'
      );
    }

    function resetHiddenPrices(scope) {
      if (!scope) return;

      scope.querySelectorAll('.lumerisa-original-price-hidden, [data-lumerisa-original-price-hidden="true"]').forEach(function (el) {
        el.classList.remove('lumerisa-original-price-hidden');
        el.removeAttribute('data-lumerisa-original-price-hidden');
        el.style.display = '';
        el.style.visibility = '';
        el.style.opacity = '';
      });
    }

    function getProductCards() {
      var seen = [];
      var cards = [];

      document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        if (link.closest('[data-lumerisa-cart]')) return;

        var card =
          link.closest('li.grid__item') ||
          link.closest('.grid__item') ||
          link.closest('.product-card-wrapper') ||
          link.closest('.card-wrapper') ||
          link.closest('.card');

        if (!card) return;
        if (seen.indexOf(card) !== -1) return;

        seen.push(card);
        cards.push(card);
      });

      return cards;
    }

    function getCardInfoArea(card) {
      if (!card) return null;

      return (
        card.querySelector('.card__information') ||
        card.querySelector('.card-information') ||
        card.querySelector('.card__content') ||
        card.querySelector('.product-card__info') ||
        card
      );
    }

    function findCardBottomPriceBox(card) {
      var infoArea = getCardInfoArea(card);

      if (!infoArea) return null;

      return (
        infoArea.querySelector('.price') ||
        infoArea.querySelector('.price__container') ||
        infoArea.querySelector('.price__regular') ||
        infoArea.querySelector('.price__sale') ||
        infoArea.querySelector('.product__price') ||
        infoArea.querySelector('.product-price') ||
        infoArea.querySelector('[data-price]') ||
        infoArea.querySelector('[data-product-price]') ||
        infoArea.querySelector('[class*="price"]')
      );
    }

    function findCardTitleAnchor(card) {
      var infoArea = getCardInfoArea(card);

      if (!infoArea) return null;

      var title =
        infoArea.querySelector('.card__heading a[href*="/products/"]') ||
        infoArea.querySelector('.full-unstyled-link[href*="/products/"]') ||
        infoArea.querySelector('h3 a[href*="/products/"]') ||
        infoArea.querySelector('h2 a[href*="/products/"]') ||
        infoArea.querySelector('a[href*="/products/"]');

      if (
        title &&
        !title.closest('.media') &&
        !title.closest('.card__media') &&
        !title.closest('.product-card__media')
      ) {
        return title;
      }

      return null;
    }

    function setGiftPriceBox(priceBox) {
      if (!priceBox) return;

      if (priceBox.closest('[data-lumerisa-cart]')) return;
      if (priceBox.closest('script')) return;
      if (priceBox.closest('style')) return;

      priceBox.classList.remove('lumerisa-original-price-hidden');
      priceBox.removeAttribute('data-lumerisa-original-price-hidden');
      priceBox.style.display = '';
      priceBox.style.visibility = '';
      priceBox.style.opacity = '';

      priceBox.innerHTML = createGiftPriceHtml();
    }

    function injectGiftPriceAfter(anchor, scope) {
      if (!scope) return;

      scope.querySelectorAll('.lumerisa-gift-price-injected').forEach(function (oldLine) {
        oldLine.remove();
      });

      var line = document.createElement('div');
      line.className = 'lumerisa-gift-price-injected';
      line.setAttribute('data-lumerisa-gift-price-injected', 'true');
      line.innerHTML = createGiftPriceHtml();

      if (anchor) {
        var target =
          anchor.closest('.card__heading') ||
          anchor.closest('h1, h2, h3') ||
          anchor;

        target.insertAdjacentElement('afterend', line);
        return;
      }

      scope.appendChild(line);
    }

    function applyCollectionGiftPrices() {
      if (!isGiftCollectionPage()) return;
      if (!hasGiftUrlFlag()) return;

      getProductCards().forEach(function (card) {
        if (!card) return;
        if (card.closest('[data-lumerisa-cart]')) return;

        card.querySelectorAll('.lumerisa-gift-price-injected').forEach(function (oldLine) {
          oldLine.remove();
        });

        resetHiddenPrices(card);

        var priceBox = findCardBottomPriceBox(card);

        if (priceBox) {
          setGiftPriceBox(priceBox);
          return;
        }

        var titleAnchor = findCardTitleAnchor(card);

        if (titleAnchor) {
          injectGiftPriceAfter(titleAnchor, card);
        }
      });
    }

    function applyProductGiftPrice() {
      if (!isProductPage()) return;
      if (!hasGiftUrlFlag()) return;

      var productArea =
        document.querySelector('product-info') ||
        document.querySelector('.product__info-container') ||
        document.querySelector('.product-info') ||
        document.querySelector('.product__info-wrapper') ||
        document.querySelector('.product') ||
        document.querySelector('main');

      if (!productArea) return;

      productArea.querySelectorAll('.lumerisa-gift-price-injected').forEach(function (oldLine) {
        oldLine.remove();
      });

      resetHiddenPrices(productArea);

      var productPrice =
        productArea.querySelector('.price') ||
        productArea.querySelector('.price__container') ||
        productArea.querySelector('.price__regular') ||
        productArea.querySelector('.price__sale') ||
        productArea.querySelector('.product__price') ||
        productArea.querySelector('.product-price') ||
        productArea.querySelector('[data-price]') ||
        productArea.querySelector('[data-product-price]') ||
        productArea.querySelector('[class*="price"]');

      if (productPrice) {
        setGiftPriceBox(productPrice);
        return;
      }

      var title =
        productArea.querySelector('.product__title') ||
        productArea.querySelector('h1') ||
        productArea.querySelector('[class*="title"]');

      injectGiftPriceAfter(title, productArea);
    }

    function forceGiftPrices() {
      if (!hasGiftUrlFlag()) return;
      if (!(isGiftCollectionPage() || isProductPage())) return;

      document.body.classList.add('lumerisa-free-gift-page');

      if (isGiftCollectionPage()) {
        document.body.classList.add('lumerisa-gift-collection-page');
        decorateGiftProductLinks();
        applyCollectionGiftPrices();
      }

      if (isProductPage()) {
        document.body.classList.add('lumerisa-gift-product-page');
        applyProductGiftPrice();
      }
    }

    function requestForceGiftPrices() {
      if (!hasGiftUrlFlag()) return;
      if (!(isGiftCollectionPage() || isProductPage())) return;

      window.clearTimeout(priceRefreshTimer);

      priceRefreshTimer = window.setTimeout(function () {
        forceGiftPrices();
      }, 80);
    }

    function updateGiftPageButtons(unlocked, giftExists) {
      if (!isGiftModePage()) return;

      var buttons = document.querySelectorAll(
        'button[name="add"], input[name="add"], button[type="submit"], [data-add-to-cart], [data-product-submit], .product-form__submit'
      );

      buttons.forEach(function (button) {
        if (button.closest('[data-lumerisa-cart]')) return;

        if (!button.dataset.lumerisaOriginalText) {
          button.dataset.lumerisaOriginalText = button.textContent || button.value || 'ADD TO CART';
        }

        button.disabled = false;
        button.classList.remove('lumerisa-gift-locked-button');

        if (button.tagName === 'INPUT') {
          button.value = button.dataset.lumerisaOriginalText;
        } else {
          button.textContent = button.dataset.lumerisaOriginalText;
        }

        if (!unlocked) {
          button.disabled = true;
          button.classList.add('lumerisa-gift-locked-button');

          if (button.tagName === 'INPUT') {
            button.value = tr('unlockAt', { amount: formatMoney(getFreeRewardThreshold(), getActiveCurrency()) }) || ('UNLOCK AT ' + formatMoney(getFreeRewardThreshold(), getActiveCurrency()));
          } else {
            button.textContent = tr('unlockAt', { amount: formatMoney(getFreeRewardThreshold(), getActiveCurrency()) }) || ('UNLOCK AT ' + formatMoney(getFreeRewardThreshold(), getActiveCurrency()));
          }
        }

        if (giftExists) {
          button.disabled = true;
          button.classList.add('lumerisa-gift-locked-button');

          if (button.tagName === 'INPUT') {
            button.value = I18N.freeTshirtAlreadyChosen || 'FREE T-SHIRT ALREADY CHOSEN';
          } else {
            button.textContent = I18N.freeTshirtAlreadyChosen || 'FREE T-SHIRT ALREADY CHOSEN';
          }
        }
      });
    }

    function applyGiftStateOnPage() {
      if (!hasGiftUrlFlag()) return;
      if (!(isGiftCollectionPage() || isProductPage())) return;

      forceGiftPrices();
      decorateGiftProductLinks();

      getCart().then(function (cartData) {
        var unlocked = getCartValueWithoutGift(cartData) >= getFreeRewardThreshold(cartData.currency);
        var giftExists = hasFreeGift(cartData);

        updateGiftPageButtons(unlocked, giftExists);
      });
    }

    function getElementText(element) {
      if (!element) return '';

      if (element.tagName === 'INPUT') {
        return String(element.value || '');
      }

      return String(element.textContent || element.getAttribute('aria-label') || '');
    }

    function findFormAddButton(form) {
      if (!form) return null;

      return (
        form.querySelector('button[name="add"]') ||
        form.querySelector('input[name="add"]') ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('[data-add-to-cart]') ||
        form.querySelector('[data-product-submit]') ||
        form.querySelector('.product-form__submit')
      );
    }

    function addFormToCart(form, trigger) {
      var formData = new FormData(form);


      setLoading(true);
      /* Perceived performance: slide the drawer in immediately.
         Cart data updates in place as soon as the network request finishes. */
      openCart();

      var preflight = Promise.resolve();

      // Only the free-gift flow needs the cart state before adding. Normal ATC should not
      // pay for an extra /cart.js request before the actual add-to-cart request.
      if (shouldTreatCurrentAddAsGift()) {
        preflight = getCart().then(function (cartData) {
          var unlocked = getCartValueWithoutGift(cartData) >= getFreeRewardThreshold(cartData.currency);

          if (!unlocked) {
            setLoading(false);
            alert(tr('unlockFreeTshirtAlert', { amount: formatMoney(getFreeRewardThreshold(cartData.currency), cartData.currency) }) || 'Unlock your free T-shirt.');
            throw new Error('Gift locked');
          }

          if (hasFreeGift(cartData)) {
            setLoading(false);
            alert(I18N.oneFreeTshirtAlert || 'You can only choose one free T-shirt.');
            throw new Error('Gift already chosen');
          }

          formData.set('quantity', '1');
          formData.set('properties[_free_tshirt_gift]', 'true');
          formData.set('properties[_free_gift]', 'Free T-Shirt Gift');
          formData.set('properties[_free_gift_source]', 'Lumérisa Cart Reward');
        });
      }

      return preflight
        .then(function () {
          return fetch(storefrontRoute('cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: formData
          });
        })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(getCart)
        .then(function (cartData) {
          if (hasFreeGift(cartData)) {
            clearGiftSession();
          }

          renderCart(cartData);
          setLoading(false);
          applyGiftStateOnPage();
        })
        .catch(function (error) {
          setLoading(false);

          if (String(error && error.message).indexOf('Gift') === -1) {
            console.warn('[Lumérisa Cart] Add failed:', error);
          }
        });
    }

    function changeItem(line, quantity) {
      setLoading(true);

      return fetch(storefrontRoute('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          renderCart(cartData);
          setLoading(false);
          applyGiftStateOnPage();
        })
        .catch(function () {
          setLoading(false);
        });
    }

    function chooseGift() {
      getCart().then(function (cartData) {
        var unlocked = getCartValueWithoutGift(cartData) >= getFreeRewardThreshold(cartData.currency);

        if (!unlocked) {
          alert(tr('unlockFreeTshirtAlert', { amount: formatMoney(getFreeRewardThreshold(cartData.currency), cartData.currency) }) || 'Unlock your free T-shirt.');
          return;
        }

        if (hasFreeGift(cartData)) {
          alert(I18N.alreadyChosenAlert || 'You have already chosen your free T-shirt.');
          return;
        }

        activateGiftSession();
        window.location.href = storefrontRoute('collections/' + FREE_GIFT_COLLECTION_HANDLE) + '?lumerisa_gift=1';
      });
    }

    function updateCheckoutLink(cartData) {
      if (!checkoutLink) return;

      if (FREE_GIFT_DISCOUNT_CODE && hasFreeGift(cartData)) {
        checkoutLink.href = storefrontRoute('checkout') + '?discount=' + encodeURIComponent(FREE_GIFT_DISCOUNT_CODE);
      } else {
        checkoutLink.href = storefrontRoute('checkout');
      }
    }

    function renderRewards(cartData) {
      var eligibleTotal = getCartValueWithoutGift(cartData);
      var shippingThreshold = getFreeShippingThreshold(cartData.currency);
      var giftThreshold = getFreeRewardThreshold(cartData.currency);
      var shippingUnlocked = eligibleTotal >= shippingThreshold;
      var giftUnlocked = eligibleTotal >= giftThreshold;
      var progress = Math.min(100, Math.round((eligibleTotal / Math.max(giftThreshold, 1)) * 100));
      var shippingMissing = Math.max(0, shippingThreshold - eligibleTotal);
      var giftMissing = Math.max(0, giftThreshold - eligibleTotal);
      var giftExists = hasFreeGift(cartData);
      var giftFreePrice = document.querySelector('[data-lumerisa-gift-free-price]');
      var giftComparePrice = document.querySelector('[data-lumerisa-gift-compare-price]');
      if (giftFreePrice) giftFreePrice.textContent = formatMoney(0, cartData.currency);
      if (giftComparePrice) {
        giftComparePrice.textContent = formatMoney(
          baseToPresentmentCents(FREE_GIFT_COMPARE_PRICE_BASE, cartData.currency),
          cartData.currency
        );
      }

      if (progressFill) progressFill.style.width = progress + '%';

      if (rewardTitle) {
        if (!shippingUnlocked) {
          rewardTitle.textContent = tr('addToUnlockShipping', { amount: formatMoney(shippingMissing, cartData.currency) }) || ('Add ' + formatMoney(shippingMissing, cartData.currency));
        } else if (!giftUnlocked) {
          rewardTitle.textContent = tr('shippingUnlockedAddGift', { amount: formatMoney(giftMissing, cartData.currency) }) || ('Add ' + formatMoney(giftMissing, cartData.currency));
        } else {
          rewardTitle.textContent = I18N.shippingAndGiftUnlocked || 'FREE SHIPPING and FREE T-SHIRT unlocked';
        }
      }

      if (rewardStep) {
        rewardStep.textContent = giftUnlocked ? '2 / 2' : (shippingUnlocked ? '1 / 2' : '0 / 2');
      }

      if (shipping) {
        shipping.textContent = shippingUnlocked ? (I18N.freeShipping || 'Free Shipping') : (I18N.calculatedAtCheckout || 'Calculated at checkout');
      }

      if (giftBox) {
        giftBox.classList.toggle('is-locked', !giftUnlocked || giftExists);
      }

      if (giftButton) {
        if (giftExists) {
          giftButton.textContent = I18N.freeTshirtChosen || 'FREE T-SHIRT CHOSEN';
          giftButton.classList.add('is-locked');
          giftButton.disabled = true;
        } else if (giftUnlocked) {
          giftButton.textContent = I18N.chooseFreeTshirt || 'CHOOSE FREE T-SHIRT';
          giftButton.classList.remove('is-locked');
          giftButton.disabled = false;
        } else {
          giftButton.textContent = I18N.locked || 'LOCKED';
          giftButton.classList.add('is-locked');
          giftButton.disabled = true;
        }
      }
    }

    function renderCart(cartData) {
      var displayTotal = getCartValueWithoutGift(cartData);

      subtotal.textContent = formatMoney(displayTotal, cartData.currency);

      if (cartCount) {
        cartCount.textContent = '(' + (cartData.item_count || 0) + ')';
      }

      renderRewards(cartData);
      updateCheckoutLink(cartData);

      window.__lumerisaLastCartData = cartData;
      document.dispatchEvent(new CustomEvent('lumerisa:cart-rendered', { detail: cartData }));

      var items = cartData.items || [];

      if (!items.length) {
        body.innerHTML = '<div class="lumerisa-cart__empty">' + escapeHtml(I18N.empty || 'Your cart is empty.') + '</div>';
        return;
      }

      body.innerHTML = items.map(function (item) {
        var originalLine = items.findIndex(function (cartItem) {
          return cartItem.key === item.key;
        }) + 1;

        var freeGift = isFreeGiftItem(item);

        var image = item.image
          ? '<img class="lumerisa-cart__item-image" src="' + imageUrl(item.image, 320) + '" alt="' + escapeHtml(item.product_title) + '">'
          : '<div class="lumerisa-cart__item-image"></div>';

        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="lumerisa-cart__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '<p class="lumerisa-cart__item-variant"></p>';

        var title = freeGift ? item.product_title + ' - ' + (I18N.freeGiftSuffix || 'Free Gift') : item.product_title;
        var price = renderItemPrice(item, cartData, freeGift);

        return (
          '<div class="lumerisa-cart__item ' + (freeGift ? 'is-free-gift ' : '') + '" data-line="' + originalLine + '">' +
            '<a href="' + item.url + '">' + image + '</a>' +
            '<div class="lumerisa-cart__item-info">' +
              '<p class="lumerisa-cart__item-title">' + escapeHtml(title) + '</p>' +
              variant +
              '<div class="lumerisa-cart__qty-row">' +
                '<button class="lumerisa-cart__qty-btn" type="button" data-lumerisa-minus>−</button>' +
                '<span class="lumerisa-cart__qty-number">' + item.quantity + '</span>' +
                '<button class="lumerisa-cart__qty-btn" type="button" data-lumerisa-plus ' + (freeGift ? 'disabled' : '') + '>+</button>' +
              '</div>' +
            '</div>' +
            '<div class="lumerisa-cart__item-side">' +
              '<div class="lumerisa-cart__item-price">' + price + '</div>' +
              '<button class="lumerisa-cart__remove" type="button" data-lumerisa-remove>' + escapeHtml(I18N.remove || 'Remove') + '</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    window.LumerisaCartMoney = {
      formatMoney: formatMoney,
      getFreeShippingThreshold: getFreeShippingThreshold,
      getFreeRewardThreshold: getFreeRewardThreshold,
      baseToPresentmentCents: baseToPresentmentCents,
      getActiveCurrency: getActiveCurrency
    };
    window.renderCart = renderCart;
    window.openLumerisaCart = openCart;

    window.addEventListener('submit', function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';

      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addFormToCart(form);
    }, true);

    window.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;

      if (!target) return;

      var giftButtonClicked = target.closest('[data-lumerisa-gift-button]');

      if (giftButtonClicked) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        chooseGift();
        return;
      }

      if (isGiftCollectionPage() && hasGiftUrlFlag()) {
        var productLink = target.closest('a[href*="/products/"]');

        if (productLink && !productLink.closest('[data-lumerisa-cart]')) {
          decorateGiftProductLinks();
        }
      }

      var cartTrigger = target.closest(
        'a[href="/cart"], a[href*="/cart"], [data-cart-toggle], [data-cart-drawer-open], [aria-controls*="cart"], [aria-controls*="Cart"]'
      );

      if (cartTrigger && !target.closest('[data-lumerisa-cart]')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        setLoading(true);
        openCart();

        getCart()
          .then(function (cartData) {
            renderCart(cartData);
          })
          .catch(function (error) {
            console.warn('[Lumérisa Cart] Refresh failed:', error);
          })
          .finally(function () {
            setLoading(false);
          });

        return;
      }

      var button = target.closest(
        'button[name="add"], input[name="add"], button[type="submit"], [data-add-to-cart], [data-product-submit], .product-form__submit'
      );

      if (!button) return;

      var form = button.closest('form');

      if (!form) return;

      var action = form.getAttribute('action') || '';

      if (action.indexOf('/cart/add') === -1 && button.getAttribute('name') !== 'add') return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addFormToCart(form, button);
    }, true);

    body.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;

      if (!target) return;

      var item = target.closest('.lumerisa-cart__item');

      if (!item) return;

      var line = Number(item.getAttribute('data-line'));
      var qtyEl = item.querySelector('.lumerisa-cart__qty-number');
      var quantity = Number(qtyEl ? qtyEl.textContent : 1);

      if (target.closest('[data-lumerisa-minus]')) {
        changeItem(line, Math.max(0, quantity - 1));
      }

      if (target.closest('[data-lumerisa-plus]')) {
        if (item.classList.contains('is-free-gift')) return;
        changeItem(line, quantity + 1);
      }

      if (target.closest('[data-lumerisa-remove]')) {
        changeItem(line, 0);
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeCart);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCart);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCart();
    });

    applyGiftStateOnPage();

    function runGiftModeVisuals() {
      if (!hasGiftUrlFlag()) return;
      if (!(isGiftCollectionPage() || isProductPage())) return;

      applyGiftStateOnPage();
      forceGiftPrices();
      decorateGiftProductLinks();
    }

    if (hasGiftUrlFlag() && (isGiftCollectionPage() || isProductPage())) {
      document.addEventListener('DOMContentLoaded', runGiftModeVisuals);

      window.setTimeout(runGiftModeVisuals, 100);
      window.setTimeout(runGiftModeVisuals, 350);
      window.setTimeout(runGiftModeVisuals, 800);
      window.setTimeout(runGiftModeVisuals, 1600);
      window.setTimeout(runGiftModeVisuals, 3000);
      window.setTimeout(runGiftModeVisuals, 5000);

      var giftObserver = new MutationObserver(function () {
        requestForceGiftPrices();
        decorateGiftProductLinks();
      });

      giftObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();

/* Cart trust and free-shipping status: event-driven, no global polling. */
(function () {
  if (window.__lumerisaCartTrustShippingFix) return;
  window.__lumerisaCartTrustShippingFix = true;


  function formatMoney(cents, currency) {
    if (window.LumerisaCartMoney && window.LumerisaCartMoney.formatMoney) {
      return window.LumerisaCartMoney.formatMoney(cents, currency);
    }
    var activeCurrency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (window.LumerisaMoneyConfig && window.LumerisaMoneyConfig.baseCurrency) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: activeCurrency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + activeCurrency;
    }
  }

  function getFreeShippingThreshold(currency) {
    if (window.LumerisaCartMoney && window.LumerisaCartMoney.getFreeShippingThreshold) {
      return window.LumerisaCartMoney.getFreeShippingThreshold(currency);
    }
    return 7500;
  }

  function isFreeGiftItem(item) {
    if (!item) return false;
    var properties = item.properties || {};
    return (
      properties._free_tshirt_gift === 'true' ||
      properties._free_gift === 'Free T-Shirt Gift' ||
      properties._free_gift_source === 'Lumérisa Cart Reward'
    );
  }

  function getCartValueWithoutGift(cartData) {
    return (cartData.items || []).reduce(function (sum, item) {
      return isFreeGiftItem(item) ? sum : sum + (item.final_line_price || 0);
    }, 0);
  }

  function ensureCartExtras() {
    var cart = document.querySelector('[data-lumerisa-cart]') || document.querySelector('.lumerisa-cart');
    var template = document.querySelector('#lumerisa-cart-extra-template');
    if (!cart || !template) return;

    var timer = cart.querySelector('.lumerisa-cart__timer');
    var footerInner = cart.querySelector('.lumerisa-cart__footer-inner');
    var totals = cart.querySelector('.lumerisa-cart__totals');
    if (!timer || !footerInner) return;

    if (!cart.querySelector('[data-lumerisa-cart-trust-fix]')) {
      var trustBar = template.querySelector('[data-lumerisa-cart-trust-fix]').cloneNode(true);
      timer.parentNode.insertBefore(trustBar, timer);
    }

    if (!cart.querySelector('[data-lumerisa-bottom-free-shipping-fix]')) {
      var freeShippingBox = template.querySelector('[data-lumerisa-bottom-free-shipping-fix]').cloneNode(true);
      if (totals && totals.parentNode) {
        totals.insertAdjacentElement('afterend', freeShippingBox);
      } else {
        footerInner.appendChild(freeShippingBox);
      }
    }
  }

  function updateFreeShippingState(cartData) {
    if (!cartData) return;
    ensureCartExtras();

    var cart = document.querySelector('[data-lumerisa-cart]') || document.querySelector('.lumerisa-cart');
    if (!cart) return;

    var shippingText = cart.querySelector('[data-lumerisa-cart-shipping]');
    var bottomFreeShipping = cart.querySelector('[data-lumerisa-bottom-free-shipping-fix]');
    var eligibleTotal = getCartValueWithoutGift(cartData);
    var shippingThreshold = getFreeShippingThreshold(cartData.currency);
    var shippingUnlocked = eligibleTotal >= shippingThreshold;
    var missing = Math.max(0, shippingThreshold - eligibleTotal);

    if (shippingText) {
      shippingText.textContent = shippingUnlocked ? ((window.LumerisaI18n && window.LumerisaI18n.freeShipping) || 'Free Shipping') : ((window.LumerisaI18n && window.LumerisaI18n.calculatedAtCheckout) || 'Calculated at checkout');
    }

    if (bottomFreeShipping) {
      bottomFreeShipping.classList.toggle('is-unlocked', shippingUnlocked);
      bottomFreeShipping.textContent = shippingUnlocked
        ? ((window.LumerisaI18n && window.LumerisaI18n.freeShippingUnlocked) || '✓ FREE SHIPPING UNLOCKED')
        : (((window.LumerisaI18n && window.LumerisaI18n.addMoreFreeShipping) || 'Add __AMOUNT__ more for FREE SHIPPING').replace('__AMOUNT__', formatMoney(missing, cartData.currency)));
    }
  }

  function initialize() {
    ensureCartExtras();
    if (window.__lumerisaLastCartData) {
      updateFreeShippingState(window.__lumerisaLastCartData);
    }
  }

  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('lumerisa:cart-rendered', function (event) {
    updateFreeShippingState(event.detail);
  });

  window.lumerisaCartExtrasUpdate = updateFreeShippingState;
  initialize();
})();

(function () {
  if (customElements.get('lumerisa-native-cart-rewards')) return;

  class LumerisaNativeCartRewards extends HTMLElement {
    connectedCallback() {
      this.renderRewardState();
      var button = this.querySelector('[data-lumerisa-native-gift-button]');
      if (button && !button.dataset.lumerisaBound) {
        button.dataset.lumerisaBound = 'true';
        button.addEventListener('click', this.addGift.bind(this));
      }
    }

    currency() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || this.dataset.baseCurrency || (window.LumerisaMoneyConfig && window.LumerisaMoneyConfig.baseCurrency) || 'EUR';
    }

    rate() {
      if (this.currency() === (this.dataset.baseCurrency || 'EUR')) return 1;
      var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return Number.isFinite(rate) && rate > 0 ? rate : 1;
    }

    threshold(baseCents) {
      return Math.round(Number(baseCents || 0) * this.rate());
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.currency()
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2) + ' ' + this.currency();
      }
    }

    template(name, amount) {
      return String(this.dataset[name] || '').replace('__AMOUNT__', amount || '');
    }

    renderRewardState() {
      var total = Number(this.dataset.cartTotal || 0);
      var shipping = this.threshold(this.dataset.freeShippingBase || 7500);
      var gift = this.threshold(this.dataset.freeGiftBase || 20000);
      var giftInCart = this.dataset.giftInCart === 'true';
      var message = this.querySelector('[data-lumerisa-native-reward-message]');
      var fill = this.querySelector('[data-lumerisa-native-reward-fill]');
      var dot = this.querySelector('[data-lumerisa-native-reward-dot]');
      var tile = this.querySelector('[data-lumerisa-native-gift-tile]');
      var button = this.querySelector('[data-lumerisa-native-gift-button]');
      var giftUnlocked = total >= gift;
      var shippingUnlocked = total >= shipping;
      var pct = 0;

      if (giftUnlocked) pct = 100;
      else if (shippingUnlocked) pct = gift > 0 ? Math.min(100, total * 100 / gift) : 100;
      else pct = shipping > 0 ? Math.min(100, total * 100 / shipping) : 0;

      if (fill) fill.style.width = pct + '%';
      if (dot) dot.style.left = pct + '%';

      if (message) {
        if (giftUnlocked) {
          message.textContent = '🎉 ' + (this.dataset.allUnlocked || '');
        } else if (shippingUnlocked) {
          message.textContent = '✅ ' + this.template('shippingAddGift', this.money(Math.max(0, gift - total)));
        } else {
          message.textContent = this.template('addShipping', this.money(Math.max(0, shipping - total)));
        }
      }

      if (tile) tile.style.opacity = giftUnlocked ? '1' : '.45';
      if (button) {
        if (giftInCart) {
          button.disabled = true;
          button.textContent = this.dataset.giftAdded || button.textContent;
          button.style.opacity = '.6';
          button.style.cursor = 'default';
        } else if (giftUnlocked) {
          button.disabled = false;
          button.textContent = this.dataset.chooseGift || button.textContent;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
        } else {
          button.disabled = true;
          button.textContent = this.dataset.chooseGift || button.textContent;
          button.style.opacity = '.35';
          button.style.cursor = 'not-allowed';
        }
      }
    }

    addGift() {
      var button = this.querySelector('[data-lumerisa-native-gift-button]');
      var variantId = Number(this.dataset.giftVariantId || 0);
      if (!button || !variantId || button.disabled) return;
      button.disabled = true;
      button.textContent = this.dataset.adding || button.textContent;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        window.location.reload();
      }).catch(function () {
        window.location.reload();
      });
    }
  }

  customElements.define('lumerisa-native-cart-rewards', LumerisaNativeCartRewards);
})();
